import React from 'react';
import {UserProfile} from "../../../api/api";
import {Grid} from "@material-ui/core";
import {ClientFunding} from "./ClientFunding";
import {useProfile} from "../../../hooks/useProfile";

export type ClientFundingPageProps = {
  profile: UserProfile
}

export const ClientFundingPage = (p: ClientFundingPageProps) => {
  const {client} = useProfile()

  return (
    <>
      <Grid container spacing={5}>
        <Grid item sm={12}>
          {client && client.clientPortfolioId && <ClientFunding portfolioId={client.clientPortfolioId}/>}
        </Grid>
      </Grid>
    </>
  );
};
